import React from 'react';
import Text from './../form/Text.react';
import Dropdown from './../form/Dropdown.react';
import ImageSvg from './../images/ImageSvg.react';
import _ from 'lodash';
import memberValidate from './../../utils/validates/memberValidate.js';
import helpers from './../../utils/helpers.js';
import cx from './../../utils/cx.js';
import $ from 'jquery';
import cityAutocomplete from 'cityAutocomplete';
import Recaptcha from 'react-recaptcha';

const regexes = {
  formatName: new RegExp(/^([a-zA-Z0-9]+)\[([a-zA-Z0-9]+)\]$/),
};

class RegisterFormContainer extends React.Component {
  static defaultProps = (function () {
    const countries = [];
    // getDefaultProps izipldās jau pie require('RegisterFormContainer.react'), tāpēc pārbaude
    if (typeof countries_list === 'undefined') {
      return;
    }
    // transformē priekš dropdown
    _.mapKeys(countries_list, (value, key) => {
      var country_code = "";
      if(typeof country_codes !== "undefined" && typeof country_codes[key] !== "undefined") {
        country_code = country_codes[key];
      }
      // countries.push({ key: value._id, value: value.title, attrs: { 'data-country': value.code } });
      countries.push({ key, value, attrs: { 'data-country': country_code } });
    });
    // defaultValues izmantots validēšanā, lai zinātu kurā solī ir kuri lauki
    return {
      countries,
    };
  }());

  constructor(props) {
    super(props);
    const steps = [
      {
        title: _.get(translations, 'txt: reģistrējies bez maksas', ''),
        submit: _.get(translations, 'txt: Tālāk', ''),
        defaultValues: {
          email: '',
          email_check: '',
          /* properties: {
           *   phone: ' '
           * }, */
          password: '',
          password_check: '',
        },
      },
      {
        title: _.get(translations, 'txt: nedaudz par tevi', ''),
        /* submit: "tālāk" */
        submit: _.get(translations, 'txt: Tālāk', ''),
        defaultValues: {
          profile: {
            name: ' ',
            birth: {
              day: 0,
              month: 0,
              year: 0,
            },
            country_id: '0',
            city_id: '0',
            sex: '0',
          },
          properties: {
            no_spam: null,
            share_profile_image: null,
            agree_to_privacy_policy: null,
          },
          agree: '1',
          'g-recaptcha-response': '',
        },
      },
    ];

    let excluded = [];
    /* if (!this.props.sms_activation) {
       delete steps[0]['defaultValues']['properties']['phone'];
     * } */
    // external reģistrācijai nav captcha
    if (props.external) {
      excluded.push('g-recaptcha-response');
      delete steps[1]['g-recaptcha-response'];
    } else {
      excluded.push('agree');
      delete steps[1].agree;
    }
    if (props.excluded) {
      excluded = _.union(excluded, props.excluded);
    }

    let formData = {};
    let emailFieldDisabled = false;
    // member datiem vajadzētu būt tādai pašai struktūrai kā formData
    if (typeof member !== 'undefined') {
      formData = member;
      const email = _.get(member, 'email', null);
      // ja external register un epasts jau padots, epasta laukam jābūt disabled
      // izņēmums, ja ir epasta errori, kas var būt, piemēram, reģistrējoties ar draugiem pasi, kur epasts netiek iegūts no api, un jāievada manuāli
      if (email !== null && props.external && (typeof formData.errors === 'undefined' || typeof formData.errors.email === 'undefined')) {
        emailFieldDisabled = true;
        excluded.push('email_check');
      }
    }
    // sākumā nekad nevaajdzētu būt uzstādītai parolei (pie submit resetojas)
    // delete formData['password'];
    // delete formData['password_check'];
    delete formData['g-recaptcha-response'];
    let activeStep = 1;
    helpers.iterateThroughObject(steps[0].defaultValues, (value, key, aggrKey) => {
      if (_.get(formData, aggrKey, null) == null) {
        activeStep = 0;
      }
    });
    let errors = memberValidate.checkData(formData, excluded);
    // This is in cases when form gets submited with errors
    if (!errors.length && typeof formData.errors !== 'undefined') {
      const profile = {};
      activeStep = 1;
      _.forEach(formData.errors, (value, key) => {
        value.length = 1;
        if (activeStep == 1 && Object.keys(steps[0].defaultValues).includes(key)) {
          activeStep = 0;
        }
        if (key == 'name' || key == 'sex') {
          profile[key] = value;
        } else if (key == 'age') {
          profile.birth = {
            day: ' ',
            month: ' ',
            year: value
          };
        } else {
          errors[key] = value;
        }
      });
      errors.profile = profile;
    }

    this.state = {
      emailFieldDisabled,
      attemptedSubmit: false,
      activeStep,
      formData,
      errors,
      excluded,
      steps,
      submitted: false,
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyPress, false);
    // nevar strādāt bez tulkojuiem
    if (typeof this.props.translations === 'undefined') {
      return;
    }
    const error_translations = _.get(this.props.translations, 'errors', null);
    // inicializē kļūdu tulkojumus
    memberValidate.initTranslations(error_translations);

    if (this.state.activeStep == 1) {
      $(this.refs.cityAutocomplete).cityAutocomplete({ input_id: '#MembersProfilePlaceId' });
    }

    $('#MembersProfilePlaceIdAutocomplete').val(_.get(this.state.formData, 'profile.place_id_autocomplete', ''));
    $('#MembersProfilePlaceId').val(_.get(this.state.formData, 'profile.place_id', ''));

    // This fixes 'reCAPTCHA couldn't find user-provided function: recaptchaOnLoad'.
    // That error message actually gets logged in console in production as well. Tho everything seems to work, so I guess.. not sooo important.
    // Anyway, in new version it will be fixed.
    window.recaptchaOnLoad = this.recaptchaOnLoad;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.activeStep == 1) {
      $(this.refs.cityAutocomplete).positionCityAutocomplete();
    }
    // tiek pārbaudīts šeit, jo elementam jābūt jau uzrenderētam, lai izsauktu cityAutocomplete
    if (
      (prevState.activeStep != this.state.activeStep) &&
      this.state.activeStep == 1
    ) {
      $(this.refs.cityAutocomplete).cityAutocomplete({ input_id: '#MembersProfilePlaceId' });
    }
  }

  handleKeyPress = (event) => {
    if (event.key == 'Enter' && this.state.activeStep <= 1) {
      if (this.state.activeStep == 0) {
        this.handleStepChange(1, this.state.activeStep);
      } else if (this.state.activeStep == 1) {
        this.submit(1);
      }
    }
  };

  submit = (step, e) => {
    const result = this.hasErrors(step);
    const submitted = this.state.submitted;
    if (!result && !submitted) {
      $('form#MembersRegister').submit();
      $(e.target).addClass('has-loader');
      this.setState({ submitted: true });
    }
  };

  handleStepChange = (newStep, oldStep) => {
    // nedrīkst mainīt soli, ja ir kļūdas
    if (oldStep !== null && this.hasErrors(oldStep)) {
      return;
    }
    if (this.props.external && _.get(this.state.steps[oldStep], 'defaultValues.email', null) !== null) {
      if (!this.validateEmailWithServer()) {
        return;
      }
    }
    // ja nomainīts solis, reseto attemptedSubmit
    this.setState({
      attemptedSubmit: false,
      activeStep: newStep,
    });
  };

  handleNoSpamChange = (value) => {
    const data = {};
    data['properties.no_spam'] = value;
    this.setFormData(data);
  }

  setFormData = (data) => {
    const defaults = _.clone(this.state.steps[this.state.activeStep].defaultValues, true);
    let newData = {};
    _.mapKeys(data, (value, key) => {
      _.set(newData, key.replace(regexes.formatName, '$1.$2'), value);
    });
    const _this = this;
    newData = _.merge(defaults, this.state.formData, newData);
    // ja pirmo reizi aizpilda soļa laukus (attemptedSubmit == false),
    // nečeko errorus pie katra state change
    if (this.state.attemptedSubmit) {
      const errors = memberValidate.checkData(newData, _this.state.excluded);
      this.setState({
        errors,
      });
    }
    this.setState({
      formData: newData,
    });
  };

  handleRadioCheck = (e) => {
    const data = {};
    data[e.target.name] = e.target.value;
    this.setFormData(data);
  };

  handleCheckboxCheck = (e) => {
    const data = {};
    data[e.target.name] = e.target.checked ? 1 : 0;
    this.setFormData(data);
  };

  validateEmailWithServer = () => {
    const errors = this.state.errors;
    errors.email = memberValidate.rules.email_server(this.state.formData.email);
    this.setState({
      errors,
    });
    if (errors.email) {
      return false;
    }

    return true;
  };

  recaptchaOnLoad = () => {
  };

  handleRecaptcha = (response) => {
    const data = {};
    data['g-recaptcha-response'] = response;
    this.setFormData(data);
  };

  hasErrors = (step) => {
    const defaults = this.state.steps[step].defaultValues;
    // šeit notiek merge ar default vērtībām
    const allData = _.merge(_.clone(defaults, true), this.state.formData);
    const errors = memberValidate.checkData(allData, this.state.excluded);
    let result = false;
    helpers.iterateThroughObject(errors, (value, key, aggrKey) => {
      // ja errors neattiecas uz šo soli, izlaiž
      if (_.get(defaults, aggrKey, undefined) === undefined) {
        return false;
      }
      if (value) {
        result = true;
      }
    });

    // ja ir kaut kāds error message, neļauj veikt darbību
    if (result) {
      this.setState({
        attemptedSubmit: true,
        errors,
      });
      window.scrollTo(0, 0);
    }

    return result;
  };

  render() {
    // lai būtu īsāk
    const email = _.get(this.state.formData, 'email', '');
    const emailCheck = _.get(this.state.formData, 'email_check', '');
    const emailCheckError = _.get(this, 'state.errors.email_check', null);
    let emailCheckMarkClassBase = 'registrationForm-password ';
    if (emailCheckError) {
      emailCheckMarkClassBase += 'registrationForm-password-with-error ';
    }
    const password = _.get(this.state.formData, 'password', '');
    const passwordCheck = _.get(this.state.formData, 'password_check', '');
    const passwordCheckError = _.get(this, 'state.errors.password_check', null);
    let checkMarkClassBase = 'registrationForm-password ';
    if (passwordCheckError) {
      checkMarkClassBase += 'registrationForm-password-with-error ';
    }
    const sexError = _.get(this.state.errors, 'profile.sex', null);
    const agreeError = _.get(this.state.errors, 'agree', null);
    const captchaError = _.get(this.state.errors, 'g-recaptcha-response', null);
    const noSpam = _.get(this.state.formData, 'properties.no_spam', null);
    const noSpamError = _.get(this.state.errors, 'properties.no_spam', null);
    const birthdayError = _.get(this.state.errors, 'profile.birth.year', null);

    const agreePrivacyPolicyError = _.get(this.state.errors, 'properties.agree_to_privacy_policy', null);

    return (
      <div className="registerFormContainer">
        <input type="hidden" name="security[field_token]" value={this.props.field_token} />
        <div className="registerFormContainer-dots">
          <ul>
            <li
              className={cx([['is-active', this.state.activeStep == 0]])}
              onClick={this.handleStepChange.bind(this, 0, null)}
            />
            <li
              className={cx([['is-active', this.state.activeStep == 1]])}
              onClick={this.handleStepChange.bind(this, 1, null)}
            />
            <li />
          </ul>
        </div>
        <div className={cx(['registerFormStep', ['is-hidden', this.state.activeStep !== 0]])}>
          <h2 className="registerFormStep-title">
            {this.state.steps[0].title}
          </h2>
          <br />
          <div className="registerFormStep-group">
            <div className="registerFormStep-label">
              {this.props.translations.email.label}
            </div>
            <div className="mbm">
              <Text
                setFormData={this.setFormData}
                name="email"
                readonly={this.state.emailFieldDisabled}
                errorMsg={_.get(this, 'state.errors.email', null)}
                value={email}
                placeholder={this.props.translations.email.label}
              />
            </div>
            {!this.state.excluded.includes('email_check') && (
              <div>
                <Text
                  setFormData={this.setFormData}
                  name="email_check"
                  errorMsg={emailCheckError}
                  value={emailCheck}
                  placeholder={this.props.translations.email_check.label}
                />
                {(email !== '' && emailCheck !== '') && (
                  <div className={`${emailCheckMarkClassBase}registrationForm-password--${email === emailCheck ? 'ok' : 'notok'  }`} />
                )}
              </div>
            )}
            <div className="registerFormStep-infoText">
              {this.props.translations.email.info}
            </div>
          </div>
          {/*
          <div className="registerFormStep-group">
            <div className="registerFormStep-label">
              {this.props.translations['properties.phone'].label}
            </div>
            <Text
              setFormData={this.setFormData}
              type='number'
              name='properties[phone][]'
              errorMsg={_.get(this, 'state.errors.properties.phone', null)}
              value={_.get(this.state.formData, 'properties.phone', '')}
              placeholder={this.props.translations['properties.phone'].label}
            />
          </div>
          */}
          <div className="registerFormStep-group">
            <div className="registerFormStep-label">
              {this.props.translations.password.label}
            </div>
            <div className="mbm">
              <Text
                type="password"
                className=""
                setFormData={this.setFormData}
                value={_.get(this.state.formData, 'password', '')}
                errorMsg={_.get(this, 'state.errors.password', null)}
                name="password"
                placeholder={this.props.translations.password.label}
              />
            </div>
            <Text
              type="password"
              setFormData={this.setFormData}
              value={_.get(this.state.formData, 'password_check', '')}
              errorMsg={passwordCheckError}
              name="password_check"
              placeholder={this.props.translations.password_check.label}
            />
            {(password !== '' && passwordCheck !== '') && (
              <div className={`${checkMarkClassBase}registrationForm-password--${password === passwordCheck ? 'ok' : 'notok'  }`} />
            )}
            <div className="registerFormStep-infoText">
              {this.props.translations.password.info}
            </div>
          </div>
          <div className="registerFormStep-group mtm">
            <a
              className="btn btn--a btn--block btn--iconStatic tal ttu"
              onClick={this.handleStepChange.bind(this, 1, 0)}
            >
              <ImageSvg svg="icon-arrowrightlight" iconClass="icon-arowRightLight icon--arrowRightLight fr mtxs" />
              {this.state.steps[0].submit}
            </a>
          </div>
        </div>
        <div className={cx(['registerFormStep', ['is-hidden', this.state.activeStep !== 1]])}>
          <h2 className="registerFormStep-title">
            {this.state.steps[1].title}
          </h2>
          <br />
          <div className="registerFormStep-group">
            <Text
              setFormData={this.setFormData}
              name="profile[name]"
              errorMsg={_.get(this, 'state.errors.profile.name', null)}
              value={_.get(this.state.formData, 'profile.name', '')}
              placeholder={this.props.translations['profile.name'].label}
            />
          </div>
          <div className="registerFormStep-group">
            <div
              className={cx([
                'form-group',
                'tac',
                'form-group-radio',
                ['error', sexError !== null],
              ])}
            >
              <div className="dib prl">
                <div className="form-radio">
                  <input type="hidden" name="profile[sex]" value={0} />
                  <label>
                    <input
                      type="radio"
                      name="profile[sex]"
                      onClick={this.handleRadioCheck}
                      value="F"
                      defaultChecked={_.get(this.state.formData, 'profile.sex', null) == 'F'}
                    />
                    {this.props.translations['profile.sex'].f.label}
                  </label>
                </div>
              </div>
              <div className="dib prl">
                <div className="form-radio">
                  <label>
                    <input
                      type="radio"
                      name="profile[sex]"
                      onClick={this.handleRadioCheck}
                      value="M"
                      defaultChecked={_.get(this.state.formData, 'profile.sex', null) == 'M'}
                    />
                    {this.props.translations['profile.sex'].m.label}
                  </label>
                </div>
              </div>
              {sexError && (
                <div className="error">
                  <div className="inner">
                    {sexError}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div
            className={cx([
              'form-group registerFormStep-group',
              ['error', birthdayError],
            ])}
          >
            <div className="registerFormStep-label">
              {this.props.translations['profile.birth'].label}
            </div>
            <Dropdown
              setFormData={this.setFormData}
              name="profile[birth][day]"
              wrapClass="dib g-b--1of3 prs"
              value={_.get(this.state.formData, 'profile.birth.day', '0')}
              placeholder={this.props.translations['profile.birth.day'].label}
              noEmptyOption
              options={this.props.translations['profile.birth.day'].list}
              valueKey="key"
              label="value"
            />
            <Dropdown
              setFormData={this.setFormData}
              name="profile[birth][month]"
              wrapClass="dib g-b--1of3 prs"
              value={_.get(this.state.formData, 'profile.birth.month', '0')}
              placeholder={this.props.translations['profile.birth.month'].label}
              noEmptyOption
              options={this.props.translations['profile.birth.month'].list}
              valueKey="key"
              label="value"
            />
            <Dropdown
              setFormData={this.setFormData}
              name="profile[birth][year]"
              wrapClass="dib g-b--1of3"
              noEmptyOption
              placeholder={this.props.translations['profile.birth.year'].label}
              value={_.get(this.state.formData, 'profile.birth.year', '0')}
              options={this.props.translations['profile.birth.year'].list}
              valueKey="key"
              label="value"
            />
            {birthdayError && (
              <div className="error">
                <div className="inner">
                  {birthdayError}
                </div>
              </div>
            )}
          </div>
          <div className="registerFormStep-group">
            <div className="registerFormStep-label">
              {this.props.translations.other.from_where}
            </div>
            <div className="mbm">
              <input
                type="hidden"
                data-country={_.get(countries_list, this.state.formData.profile.country_id, null)}
              />
              <Dropdown
                setFormData={this.setFormData}
                id="CountryId"
                name="profile[country_id]"
                noEmptyOption
                value={_.get(this.state.formData, 'profile.country_id', '0')}
                placeholder={this.props.translations['profile.country_id'].label}
                options={this.props.countries}
                valueKey="key"
                label="value"
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                placeholder={this.props.translations['profile.place_id'].label}
                name="profile[place_id_autocomplete]"
                className="form-control por"
                ref="cityAutocomplete"
                id="MembersProfilePlaceIdAutocomplete"
                autoComplete="off"
              />
              <input
                name="profile[place_id]"
                type="hidden"
                id="MembersProfilePlaceId"
              />
            </div>
          </div>
          <div className="registerFormStep-group">
            <div
              className={cx([
                'form-group registerFormStep-group mbm',
                ['error', noSpamError],
              ])}
            >
              <div className="registerFormStep-newsText pts">{this.props.translations['properties.no_spam'].label}</div>
              <a
                className={`registerFormStep-newsBtn btn btn--small pts pbs ${noSpam === 0 ? 'btn--b' : 'btn--d'} tac`}
                onClick={this.handleNoSpamChange.bind(this, 0)}
              >
                {this.props.translations['properties.no_spam'].allow_spam}
              </a>
              <a
                className={`registerFormStep-newsBtn registerFormStep-newsBtnRight btn btn--small pts pbs ${noSpam === 1 ? 'btn--b' : 'btn--d'} tac`}
                onClick={this.handleNoSpamChange.bind(this, 1)}
              >
                {this.props.translations['properties.no_spam'].no_spam}
              </a>
              <input type="hidden" name="properties[no_spam]" value={noSpam !== null ? noSpam : 1} />
              {noSpamError && (
                <div className="error">
                  <div className="inner">
                    {noSpamError}
                  </div>
                </div>
              )}
            </div>
            <div className="form-group form-group-checkbox">
              <div className="dib prl">
                <div className="form-checkbox">
                  <label>
                    <input type="hidden" name="properties[share_profile_image]" value={0} />
                    <input type="checkbox" name="properties[share_profile_image]" />
                    {this.props.translations['properties.share_profile_image'].label}
                  </label>
                </div>
              </div>
            </div>
            <div className="form-group form-group-checkbox">
              <div className="dib prl">
                <div className="form-checkbox">
                  <label>
                    <input type="hidden" name="properties[agree_to_privacy_policy]" value={0} />
                    <input type="checkbox" name="properties[agree_to_privacy_policy]" onChange={this.handleCheckboxCheck} />
                    <span dangerouslySetInnerHTML={{__html: this.props.translations["properties.agreed_to_privacy_policy"].label}} />
                  </label>
                  {agreePrivacyPolicyError && (
                    <div className="error mts">
                      <div className="inner">
                        {agreePrivacyPolicyError}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {this.props.external && (
              <div
                className={cx([
                  'form-group',
                  'form-group-checkbox',
                  ['error', agreeError],
                ])}
              >
                <div className="dib prl">
                  <div className="form-checkbox">
                    <label>
                      <input type="hidden" name="agree" value={0} />
                      <input
                        type="checkbox"
                        name="agree"
                        onClick={this.handleCheckboxCheck}
                        value="1"
                      />
                      <span dangerouslySetInnerHTML={{__html: this.props.translations.agree.label}} />
                    </label>
                  </div>
                </div>
                {agreeError && (
                  <div className="error">
                    <div className="inner">
                      {agreeError}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          {!this.props.external && (
            <div
              className={cx([
                'registerFormStep-group',
                'registrationForm-captcha',
                'mtm',
                ['error', captchaError !== null],
              ])}
            >
              <div className="g-recaptcha" id="recaptcha" />
              <Recaptcha
                elementID="recaptcha"
                render="explicit"
                onloadCallback={this.recaptchaOnLoad}
                verifyCallback={this.handleRecaptcha}
                sitekey={this.props.recaptcha_site_key}
              />
            </div>
          )}
          <div className="registerFormStep-group mtm">
            <a
              onClick={this.submit.bind(this, 1)}
              className="btn btn--a btn--block btn--iconStatic tal ttu"
            >
              <ImageSvg svg="icon-arrowrightlight" iconClass="icon-arowRightLight icon--arrowRightLight fr mtxs" />
              {this.state.steps[1].submit}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

module.exports = RegisterFormContainer;
